import Swiper from "swiper";
import { Navigation } from 'swiper/modules';
export default class SliderVideo{
    
    constructor(element) {
        this._wrapper = element;
        this._swiper =  this._wrapper.querySelector('.swiper');
        this._left = this._wrapper.querySelector('.js-slider-video-left');
        this._right = this._wrapper.querySelector('.js-slider-video-right');
        this._count = this._wrapper.querySelector('.js-slider-video-count');
        this._container = this._wrapper.querySelector('.js-slider-video-container');
        this._sliderWrapper = this._wrapper.querySelector('.js-slider-video-slider-wrapper');
        
        
        this.init();
        this.bindEvents();
        this.setSliderWrapperWidth();
    }
    
    init(){
        this.slider = new Swiper(this._swiper, {
            slidesPerView:1,
            loop:true,
            rewind:false,
            spaceBetween:24,
            modules: [Navigation],
            navigation: {
                nextEl: this._right,
                prevEl: this._left,
            },
            breakpoints:{
                576:{
                    slidesPerView:2
                },
                768:{
                    slidesPerView:3
                }, 
                1200:{
                    slidesPerView:4
                },
                1440:{
                    slidesPerView:6
                },
                1520:{
                    slidesPerView:6
                }
            }
        });
        
        this.slider.on('activeIndexChange', () => {
            this._count.innerText = this.slider.realIndex + 1;
        })
    }
    
    
    setSliderWrapperWidth(){
        let offsetLeft = this._container.offsetLeft;
        if(this.isMD()){
            this._sliderWrapper.setAttribute('style','');
        }
        else{
            this._sliderWrapper.style.width ="calc(100% - "+offsetLeft+"px)";
        }
    }
    
    bindEvents(){
        window.addEventListener('resize', app.debounce(this.setSliderWrapperWidth.bind(this)));
    }
    
    isMD(){
        return window.matchMedia('(max-width:768px)').matches;
    }
    

    
 


}